import React, { useEffect, useState, useContext, useRef } from "react";

import EnhanceTip from "./common/enhanceTip";
import { ToolFnContext } from "./utils/context";
import { getDefaultComponentStyle } from "./utils/defaultStyles";
import { Popover, Tooltip } from "antd";
import locale from "./locale";

export default ({
  data,
  getText,
  setRetrieveValues,
  btnRequestHandle,
  setSubmitState,
  isStreaming,
}: {
  data: IMultiElementCombineMsg.ISelectPersonElem;
  getText: (text: IMultiElementCombineMsg.IText | string | undefined) => string;
  setRetrieveValues: (value: IMultiElementCombineMsg.IRetrieveValues) => void;
  btnRequestHandle: ({
    url,
    retrieve_values,
    extra,
  }: IMultiElementCombineMsg.ISubmitParams) => void;
  setSubmitState: (tipCheck: IMultiElementCombineMsg.ITipCheck) => void;
  isStreaming: boolean;
}) => {
  const {
    id,
    type,
    title,
    limit = 100,
    default_person,
    placeholder_title,
    disable,
    prompt_tips,
    required,
    required_tips,
    action_url,
    extra,
  } = data;
  const [selectedUsers, setSelectedUsers] = useState<
    IMultiElementCombineMsg.IUserIdName[]
  >(default_person || []);

  const { selectPersonFn, openUserInfoCard } = useContext(ToolFnContext);
  const style = getDefaultComponentStyle(data);
  const selectPersonBoxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSelectedUsers(default_person);
  }, [default_person]);

  useEffect(() => {
    try {
      const hasUser = Array.isArray(selectedUsers) && selectedUsers.length > 0;
      const value = hasUser
        ? selectedUsers
            .map((item) => item.uuid || item.userid || item.id)
            .join()
        : "";
      setRetrieveValues({ id, type, value });
    } catch (error) {
      console.log("selectedUsers", error);
    }
  }, [selectedUsers]);

  const showUseradd = (e: any) => {
    e.stopPropagation();
    let disabledUsers: any[] = [],
      pickedUsers: any[] = [],
      lockedUsers: any[] = [];
    if (Array.isArray(selectedUsers) && selectedUsers.length > 0) {
      lockedUsers = selectedUsers.filter((item) => item.is_locked);
      // 这里的：item.uuid || item.userid =》》》  im: item.userid || item.id
      disabledUsers = lockedUsers.map(
        (item) => item.id || item.uuid || item.userid
      );
      pickedUsers = selectedUsers
        .filter((item) => !item.is_locked)
        .map((item) => item.id || item.userid || item.uuid);
    }
    // todo:
    selectPersonFn &&
      selectPersonFn(
        {
          responseUserOnly: true,
          multiple: true,
          maxUsers: limit - disabledUsers.length,
          showGroups: true,
          showPartner: true,
          disabledUsers,
          pickedUsers,
          canSelectZero: true,
        },
        (res) => {
          const mergeUser = [...lockedUsers, ...res.users];
          setSelectedUsers(mergeUser);
          setTimeout(() => {
            action_url &&
              btnRequestHandle({
                url: action_url,
                retrieve_values: [id],
                extra,
              });
          });
        }
      );
  };

  const openPersonDetail = (person: IMultiElementCombineMsg.IUserIdName) => {
    console.log("openPersonDetail", person);
    openUserInfoCard && openUserInfoCard({
      id: person.id,
    })
  };

  const morePersonListRender = () => {
    return (
      <div className={"sscard-selectMorePersonList"}>
        <div className={"seleMorePersonListTitle"}>
          <span>{`${locale('person_list')}（${Array.isArray(selectedUsers) && selectedUsers.length > 0 ? selectedUsers.length : 0}）`}</span>
        </div>
        <div className={"seleMorePersonListContent"}> {Array.isArray(selectedUsers) && selectedUsers.length > 0 && selectedUsers?.map((item) => {
          return (
            <div key={item.id} className={"seleMorePersonListContentItem"} onClick={() => openPersonDetail(item)}>
              <img
                src={`${item.pic || item.avatar
                  }?imageMogr2/auto-orient|imageView2/1/w/60/h/60|imageMogr2/ignore-error/1`}
              />
              <span className={"seleMorePersonListPersonTextBox"}>
                <span className={"seleMorePersonListPersonName"}>{`${getText(item.name)}`}</span>
                {item.work_code && <span className={"seleMorePersonListPersonId"}>{`(${item.work_code})`}</span>}
              </span>
            </div>
          );
        })}
        </div>
      </div>
    );
  };

  return (
    <div style={style}>
      <EnhanceTip
        id={id}
        isEmpty={!selectedUsers || !selectedUsers.length}
        required={required}
        required_tips={required_tips}
        prompt_tips={prompt_tips}
        isLeftGap={!!getText(title)}
        setSubmitState={setSubmitState}
      >
        <div className={`${"sscard-flexBox"} ${"sscard-selectPersonBox"}`} ref={selectPersonBoxRef}>
          {getText(title) && <span className={"desc"}>{getText(title)}</span>}
          <Popover 
            placement="bottomRight" 
            content={morePersonListRender()} 
            destroyTooltipOnHide
            getPopupContainer={() => selectPersonBoxRef.current! || document.querySelector('.sscard-selectPersonBox')!} 
            trigger={(disable || isStreaming ) && Array.isArray(selectedUsers) && selectedUsers.length > 0 ? ["click"] : []}
          >
            <span
              className={`${"selectInfo"}`}
              onClick={disable || isStreaming ? undefined : showUseradd}
            >
              {/* 用户头像部分 */}
              <span className={"selectItem"}>
                {Array.isArray(selectedUsers) && selectedUsers.length > 0
                  ? selectedUsers
                      .slice(0, 5)
                      .map((item: IMultiElementCombineMsg.IUserIdName) => {
                        return (
                          <Tooltip key={item.id} title={`${getText(item.name)}${item.work_code ? `（${item.work_code}）` : ''}`}>
                            <img
                              src={`${
                                item.pic || item.avatar
                                }?imageMogr2/auto-orient|imageView2/1/w/60/h/60|imageMogr2/ignore-error/1`}
                              />
                          </Tooltip>
                        );
                      })
                  : getText(placeholder_title)}
                  {
                    Array.isArray(selectedUsers) && selectedUsers.length > 5 && (
                      <span className={"selectMore"}>
                        {`+${selectedUsers.length - 5}`}
                      </span>
                    )
                  }
              </span>
              {/* 选人部分 */}
              {!disable && !isStreaming ? (
                <span
                  className={`${"selectPersonIcon"} ${
                    isStreaming ? "sscard-disabled" : ""
                  } iconfont-yach yach-tianjiacanyuren1`}
                ></span>
              ) : null}
            </span>
          </Popover>
        </div>
      </EnhanceTip>
    </div>
  );
};
